import { useState } from "react";
import {
    Link,
    Modal
} from "@mui/material";
import ProductSkuTable from './ProductSkuTable';
import { getProductSkus } from "../services/api";
import COLORS from '../styles/colors.json';

export default function ProductCode(props) {
    const {
        productSku,
        odsProductId
    } = props;

    const [productSkus, setProductSkus] = useState({});
    const [productSkuTableOpen, setProductSkuTableOpen] = useState(false);

    const handleClick = async () => {
        const skus = await getProductSkus(odsProductId);
        setProductSkus(skus);
        setProductSkuTableOpen(true);
    }

    return (
        <>
            <Link
                onClick={handleClick}
                color={COLORS.link}
            >
                {productSku}
            </Link>
            <Modal
                open={productSkuTableOpen}
                onClose={() => setProductSkuTableOpen(false)}
            >
                <ProductSkuTable skus={productSkus} />
            </Modal>
        </>
    );
}